import { debounce } from "@solid-primitives/scheduled";
import { getUserStore } from "~/solidJs/entities/HeaderMain/models";
import {
	showInsufficientCreditsToast,
	UserCreditsEvent,
	UserCreditsEventor
} from "~/solidJs/features/UserCreditsEventor";
import {
	getTimeUntilNewGenerations,
	isUsercanRunPricedTask,
	onNextFrame,
	setDataAtrOnlyInTests
} from "~/solidJs/shared/helpers";
import { PricingV2Methods } from "~/solidJs/shared/helpers/amplitudeExperiments/experiments/pricingV2";
import {
	isNodeDisabled,
	isNodeUnavalibleInGraphSpace,
	prepeareCostDefinition
} from "~/solidJs/shared/helpers/nodeHelpers";
import { openPricingPage } from "~/solidJs/shared/models/pageParams/pricingPageParams";
import { badgeStyles } from "~/solidJs/shared/ui/atoms/Badge/Badge";
import { CreditsBadgePopoverMethods } from "~/solidJs/widgets/CreditsBadgePopover";
import Editor from "../editor";
import { GraphNode, SocketIn, SocketOut } from "../graph/node-socket-connection";
import NodeExecutionTask from "../network/node-task";
import { TaskApi } from "../network/TaskApi";
import { NodeEvents } from "../types/IEventorListners";
import AnimatedNumber from "../utilities/components/animatedNumber";
import EventAnalytics from "../utilities/EventAnalytics";
import { Default_Executor_Text } from "../utilities/executor";
import { $div } from "../utilities/TurboDom";
import { SocketDefinition } from "./node-definition";
import "number-flow/group";
import { TeamMethods } from "~/solidJs/entities/Teams";
import { queryClient } from "~/solidJs/shared/api/queryClient";
import { TeamApi } from "~/solidJs/shared/api/TeamApi";
export const ExecutionStatus = {
	Disable: "Disable",
	Ready: "Ready",
	Starting: "Starting",
	Computing: "Computing",
	Done: "Done",
	Error: "Error"
};
Object.freeze(ExecutionStatus);

class CreditsBadge {
	/*
	 * @type {NodeType}
	 */
	node;
	constructor(node) {
		this.node = node;
		this.currentAbortController = null;

		this.creditsContainerBadge = $div(
			badgeStyles({
				variant: "creditsDark",
				size: "medium",
				class: "absolute right-4 top-1/2 -translate-y-1/2"
			})
		);
		this.creditsIconContainer = $div("credits-icon-container", this.creditsContainerBadge);
		this.creditsIconContainer.innerHTML = `
		<svg height=14 width=14 viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.51082 2.01367C8.99504 2.14817 10.9405 3.25328 10.9971 4.60645H11.0001V6.95508C8.5534 6.4837 6.58335 7.68107 6.07039 8.77539L6.10066 9.99414V12.04C3.42596 12.04 1.14693 10.9177 1.00691 9.50879L1.00008 9.37109C0.999797 8.70445 1.0004 7.66656 1.00008 7H1.00203L1.00008 6.95508C0.999797 6.28844 1.0004 5.25055 1.00008 4.58398C1.00134 4.58441 1.00272 4.58453 1.00398 4.58496C1.08542 3.15029 3.29037 2.00002 6.00008 2L6.51082 2.01367ZM2.12508 9.37109L2.13191 9.41992C2.16279 9.56196 2.3305 9.89424 3.03426 10.2598C3.54087 10.5228 4.21021 10.7277 4.97566 10.834V9.99414C4.97551 9.98937 4.97486 9.98417 4.97469 9.97852C4.97368 9.94599 4.9725 9.89894 4.97078 9.8418C4.96845 9.76455 4.96502 9.66827 4.96199 9.5625C4.48465 9.50871 4.03276 9.41862 3.61629 9.29785C3.04591 9.14195 2.54917 8.95055 2.12508 8.76172C2.12511 8.98265 2.125 9.19102 2.12508 9.37109ZM2.12508 6.95508L2.13191 7.01074C2.16297 7.16625 2.3287 7.49369 2.99422 7.84863C3.50376 8.12037 4.19269 8.33233 4.99519 8.43262C5.04687 8.30481 5.10564 8.18369 5.17 8.07227C5.31405 7.82293 5.49707 7.58751 5.70808 7.36914C4.32512 7.32601 3.29758 6.9804 2.46883 6.58496C2.35055 6.52852 2.23589 6.46982 2.12508 6.41211C2.12511 6.60831 2.12501 6.79315 2.12508 6.95508ZM6.00008 3.125C4.76694 3.12501 3.70598 3.39393 2.99422 3.77344C2.23426 4.17876 2.12512 4.54829 2.12508 4.66699C2.12535 4.78611 2.23514 5.15471 2.99422 5.55957C3.70598 5.93909 4.76692 6.208 6.00008 6.20801C7.23333 6.20797 8.2942 5.93915 9.00594 5.55957C9.76504 5.1547 9.8748 4.78611 9.87508 4.66699C9.87504 4.54829 9.7659 4.17876 9.00594 3.77344C8.2942 3.39387 7.2333 3.12504 6.00008 3.125Z" fill="currentColor"/>
    <path d="M10.2571 6.00384C12.8616 6.07776 14.9383 7.26732 14.9963 8.73585L15 8.73508V11.2011L14.9934 11.3449C14.8596 12.8237 12.675 14 10 14L9.74293 13.9962C7.18641 13.9236 5.13686 12.776 5.00732 11.3449L5.00073 11.2011C5.00045 10.5014 5.00033 9.41172 5 8.71202L5.00366 8.71356C5.08432 7.20733 7.28975 6 10 6L10.2571 6.00384ZM13.5213 10.7891C13.5057 10.7966 13.4895 10.8031 13.4737 10.8106C12.5743 11.2974 11.3499 11.5977 10 11.5978L9.7422 11.5939C8.51698 11.5591 7.40851 11.2767 6.5717 10.8352C6.5416 10.821 6.51121 10.808 6.48162 10.7937C6.35864 10.7341 6.23959 10.6724 6.12495 10.6115C6.12498 10.8246 6.12561 11.0251 6.12568 11.2003C6.12578 11.325 6.2345 11.7129 6.99429 12.1382C7.70603 12.5366 8.76675 12.8192 10 12.8193C11.2334 12.8193 12.2947 12.5366 13.0064 12.1382C13.7661 11.7129 13.875 11.3258 13.8751 11.2011C13.8751 11.0174 13.8751 10.817 13.8751 10.6092C13.761 10.6694 13.6428 10.7303 13.5213 10.7891ZM10 7.18074C8.76662 7.18074 7.70534 7.46338 6.99355 7.86182C6.23368 8.28727 6.12495 8.67438 6.12495 8.79889C6.12499 8.92348 6.23379 9.31058 6.99355 9.73595C7.01436 9.7476 7.03587 9.75832 7.05727 9.76977C7.75591 10.0965 8.60647 10.3725 9.75465 10.407L10 10.4109C11.296 10.4109 12.2295 10.1038 12.9852 9.74594C12.9919 9.74225 12.9991 9.73965 13.0057 9.73595C13.7656 9.31054 13.8743 8.92349 13.8743 8.79889C13.8743 8.67437 13.7658 8.28731 13.0057 7.86182C12.294 7.4634 11.2333 7.18078 10 7.18074Z" fill="currentColor"/>
    </svg>
		`;
		this.creditsTextContainer = new AnimatedNumber(this.node.getTaskPrice().price, 500);
		this.creditsContainerBadge.append(this.creditsTextContainer.getDomElement());

		this.initHoverHandlers();
		setTimeout(() => this.initUpdateCallback());
		this.subscribeToUserCredits();
	}
	getDomElement() {
		return this.creditsContainerBadge;
	}

	/**
	 * Безопасное получение цены задачи с защитой от race conditions
	 * @param {boolean} forHover - указывает, что запрос для hover (возвращает существующую цену если она есть)
	 * @returns {Promise<Object>} костные данные
	 */
	async safeGetTaskCost(forHover = false) {
		if (forHover && this.node.getTaskPrice()) {
			return this.node.getTaskPrice();
		}

		if (this.currentAbortController) {
			this.currentAbortController.abort();
		}

		this.currentAbortController = new AbortController();

		try {
			const costData = await TaskApi.getCachedTaskCost(
				await prepeareCostDefinition(this.node),
				this.currentAbortController.signal
			);

			if (this.currentAbortController.signal.aborted) {
				return null;
			}

			this.node.setTaskPrice(costData);

			return costData;
		} catch (error) {
			// Если это AbortError, не логируем ошибку
			if (error.name === "AbortError") {
				return null;
			}
			console.error("Error while loading the price:", error);
			throw error;
		}
	}
	initHoverHandlers() {
		let hoverTimeout;

		this.creditsContainerBadge.addEventListener("mouseenter", (_event) => {
			hoverTimeout = setTimeout(async () => {
				try {
					const costData = await this.safeGetTaskCost(true);
					if (!costData) return;

					const rect = this.creditsContainerBadge.getBoundingClientRect();

					const graphPos = Editor.context.graph.navigation.clientToGraphSpace(
						rect.left,
						rect.top
					);
					const zoom = Editor.context.graph.navigation.getZoomScale();
					const position = {
						left: graphPos.x,
						top: graphPos.y,
						width: rect.width / zoom,
						height: rect.height / zoom
					};

					CreditsBadgePopoverMethods.openCreditsBadgePopover(position, {
						node: this.node,
						costData
					});
				} catch (_error) {}
			}, 500);
		});

		this.creditsContainerBadge.addEventListener("mouseleave", () => {
			if (hoverTimeout) {
				clearTimeout(hoverTimeout);
				hoverTimeout = null;
			}
		});
	}

	updateCounterAndBadgeStyle(price) {
		const data = queryClient.getQueryData(TeamApi.getTeamInfoOptions().queryKey);
		const user = getUserStore();
		const teamBalance = TeamMethods.getMemberValue(
			data,
			user,
			TeamMethods.getMemberCurrentCreditsBalance
		);
		this.updateBadgeStyle(price, teamBalance || 0, user);
		this.creditsTextContainer.update(price);
	}

	async updateFn() {
		try {
			const costData = await this.safeGetTaskCost(false);
			if (costData) {
				this.updateCounterAndBadgeStyle(costData.price);
			}
		} catch (_e) {}
	}

	updateText = debounce(() => this.updateFn(), 500);
	initUpdateCallback() {
		this.updateFn();
		this.node.addListener(NodeEvents.ParamsChange, this.updateText);
		this.node.addListener(NodeEvents.InputsChange, this.updateText);
	}

	updateBadgeStyle(taskPrice, _remainingCredits, user) {
		// isUsercanRunPricedTask already handles is_infinity for team members
		const canRun = isUsercanRunPricedTask(taskPrice, user);
		if (canRun) {
			this.creditsContainerBadge.className = badgeStyles({
				variant: "creditsDark",
				size: "medium",
				class: "absolute right-4 top-1/2 -translate-y-1/2"
			});
		} else {
			this.creditsContainerBadge.className = badgeStyles({
				variant: "creditsOrange",
				size: "medium",
				class: "absolute right-4 top-1/2 -translate-y-1/2"
			});
		}
	}

	subscribeToUserCredits() {
		const onCreditsUpdate = (remainingCredits) => {
			this.updateBadgeStyle(this.node.getTaskPrice().price, remainingCredits, getUserStore());
		};
		UserCreditsEventor.addListener(UserCreditsEvent.UPDATE, onCreditsUpdate);
		const onNodeRemove = () => {
			// Отменяем текущие запросы при удалении ноды
			if (this.currentAbortController) {
				this.currentAbortController.abort();
				this.currentAbortController = null;
			}

			this.node.removeListener(NodeEvents.Remove, onNodeRemove);
			this.node.removeListener(NodeEvents.ParamsChange, this.updateText);
			this.node.removeListener(NodeEvents.InputsChange, this.updateText);

			UserCreditsEventor.removeListener(UserCreditsEvent.UPDATE, onCreditsUpdate);
		};
		this.node.addListener(NodeEvents.Remove, onNodeRemove);
	}
}

export class NodeExecutor {
	tariffDisabled;
	DOM = {};
	isExecuting = false;
	isHovered = false;
	currentProgress = 0;
	DOMStyle = {
		executeBlock: {
			start: (_text) => {
				if (this.isDisabled) return;
				this.isExecuting = true;
				this.isCancelRunningTasks = false;
				this.node.outputSocketGroup.layout.lock();
				this.node.inputSocketGroup.layout.lock();
				this.node.paramSocketGroups.socketGroups.forEach((x) => {
					x.layout.lock();
				});
				this.startProgressBar();
				this.node.paramSocketGroups.globalSettingsGroup?.layout.lock();
				this.node.layout.domElement().classList.add("execution");
				this.DOM.triggersContainer.classList.add("computing");
				this.executeBtn.classList.add("computing");
				this.creditsBadge.getDomElement().style.display = "none";
				this.updateButtonText();
			},
			finish: (text) => {
				this.isExecuting = false;
				this.isCancelRunningTasks = true;
				this.currentProgress = 0;

				this.finishProgressBar();
				this.node.outputSocketGroup.layout.unlock();
				this.node.inputSocketGroup.layout.unlock();
				this.node.paramSocketGroups.socketGroups.forEach((x) => {
					x.layout.unlock();
				});
				this.node.paramSocketGroups.globalSettingsGroup?.layout.unlock();
				this.node.layout.domElement().classList.remove("execution");
				this.DOM.triggersContainer.classList.remove("computing");
				this.executeBtn.classList.remove("computing");
				this.executeBtn.classList.remove("queued");
				this.creditsBadge.getDomElement().style.display = "inline-flex";
				if (this.isDisabled) return;
				this.executeBtnText.textContent = text || this.getStartText();
			}
		},
		statusElement: {
			style: (styleName) => {
				this.statusElement.className = `status-message ${styleName}`;
				console.log(`status-message ${styleName}`);
			}
		}
	};
	triggerSockets = {
		in: {},
		out: {}
	};
	isBasicTriggersDOMInited = false;

	/**
	 *
	 * @param {GraphNode} node
	 */
	constructor(node) {
		this.node = node;
		node.executuionBlock = this;
		this.layout = node.executionGroupLayout;
		this.initDOM();

		const setReExecuteAbility = (isAble) => {
			this.executeBtn.classList.toggle(".btn-secondary", !isAble);
			this.executeBtn.classList.toggle(".btn-primary", isAble);
		};
		node.addListener(NodeEvents.OutputsChange, () => {
			setReExecuteAbility(false);
		});
		node.addListener(NodeEvents.InputsChange, () => {
			setReExecuteAbility(true);
		});
		const isDisabled = isNodeDisabled(node.definition);
		this.creditsBadge = new CreditsBadge(node);
		this.executeBtn.appendChild(this.creditsBadge.getDomElement());
		this.toggleTarfiLimited(isDisabled);
		this.tariffDisabled = isDisabled;
	}

	getStartText() {
		if (this.node.getHasResults()) {
			this.executeBtn.classList.add("regenerate");
			return "Re-generate";
		}
		this.executeBtn.classList.remove("regenerate");
		return "Generate";
	}

	updateGenerateText() {
		if (this.isDisabled || this.tariffDisabled || this.isExecuting) {
			return;
		}
		this.executeBtnText.textContent = this.getStartText();
	}

	initDOM() {
		this.mainContainer = $div("execute-main-container");

		this.executeBtn = document.createElement("button");
		this.executeBtn.classList.add("execute-btn");

		// Создаем прогресс-бар
		this.progressBar = $div("execute-btn-progress", this.executeBtn);
		this.progressBar.style.width = "0%";
		this.progressBar.style.opacity = "1";

		this.executeBtnText = $div("execute-btn-text");
		this.executeBtn.append(this.executeBtnText);

		this.addFeatureStyles();
		this.initHoverListeners();

		if (!this.tariffDisabled) {
			setTimeout(() => {
				this.updateGenerateText();
			}, 0);
		}

		this.node.layout.DOM.nodeHeaderLabelGroup.append(this.executeBtn);
		setDataAtrOnlyInTests(() => {
			this.executeBtn.setAttribute("data-test", "execute-btn");
		});
		this.statusElement = $div("status-message", this.mainContainer);
		this.setStatusEnabled(false);
		this.layout.domElement().append(this.mainContainer);
	}
	addFeatureStyles() {
		this.executeBtn.classList.add("exec-feature-appearance");
		this.executeBtn.classList.add("replay-regenerate");
	}

	initHoverListeners() {
		this.executeBtn.addEventListener("mouseenter", () => {
			this.isHovered = true;
			this.updateButtonText();
		});

		this.executeBtn.addEventListener("mouseleave", () => {
			this.isHovered = false;
			this.updateButtonText();
		});
	}

	updateButtonText() {
		if (this.isHovered && (this.isExecuting || this.executeBtn.classList.contains("queued"))) {
			this.executeBtnText.textContent = "Stop";
		} else if (this.executeBtn.classList.contains("queued")) {
			this.executeBtnText.textContent = "Queued...";
		} else if (this.isExecuting && this.currentProgress > 0) {
			this.executeBtnText.textContent = `Generating ${Math.round(this.currentProgress)}%`;
		} else if (this.isExecuting) {
			this.executeBtnText.textContent = "Generating...";
		}
	}

	updateProgressBar(percentage) {
		if (this.progressBar) {
			this.progressBar.style.width = `${percentage}%`;
		}
	}

	finishProgressBar() {
		this.progressBar.style.opacity = "0";
	}

	startProgressBar() {
		this.progressBar.style.transition = "all 0s ease";
		this.progressBar.style.opacity = "1";
		this.progressBar.style.width = "0%";
		onNextFrame(() => {
			this.progressBar.style.transition = "";
		});
	}

	setProgress(percentage) {
		this.currentProgress = percentage;
		this.updateProgressBar(percentage);
		this.updateButtonText();
	}

	setQueuedState(isQueued) {
		this.executeBtn.classList.toggle("queued", isQueued);
		if (isQueued) {
			this.creditsBadge.getDomElement().style.display = "none";
		}
		this.updateButtonText();
	}

	getAvalableDataText(availableDate) {
		return availableDate
			? getTimeUntilNewGenerations(availableDate)
			: "Generation limit reached";
	}

	appendPremiumButton(isNeedToShowGetPremium, availableText) {
		if (!this.premiumButton && isNeedToShowGetPremium) {
			this.premiumButton = document.createElement("button");
			this.premiumButton.classList.add("limitPremiumButton");
			this.premiumButton.textContent = PricingV2Methods.getPremiumCopiratingText();
			this.premiumButton.addEventListener("click", (e) => {
				EventAnalytics.genDisabledBtnClick(this.node.globalId);

				e.stopPropagation();
				openPricingPage({ source: "generationLimitButton" });
			});
		}
		if (!this.limitPremiumText) {
			this.limitPremiumText = $div("limitPremiumText");
			this.limitPremiumText.textContent = availableText;
		}
		if (isNeedToShowGetPremium) {
			this.executeBtn.append(this.limitPremiumText, this.premiumButton);
			return;
		}
		this.executeBtn.append(this.limitPremiumText);
	}

	/**
	 *
	 * @param {boolean} isDisabled
	 * @param {string} availableDate
	 * @returns
	 */
	toggleDisability(isDisabled, availableDate, isByPremiumText) {
		if (this.isDisabled === isDisabled || this.tariffDisabled) {
			return;
		}
		this.isDisabled = isDisabled;
		this.executeBtn.classList.toggle("limitDisabled", isDisabled);

		this.executeBtn[isDisabled ? "removeEventListener" : "addEventListener"](
			"click",
			this.executeFunc
		);
		if (isDisabled) {
			this.executeBtnText.style.display = "none";
			this.creditsBadge.getDomElement().style.display = "none";
			this.appendPremiumButton(isByPremiumText, this.getAvalableDataText(availableDate));

			return;
		}
		this.executeBtnText.style.display = "";
		this.creditsBadge.getDomElement().style.display = "";
		if (this.premiumButton) {
			this.premiumButton.remove();
			this.premiumButton = null;
		}
		if (this.limitPremiumText) {
			this.limitPremiumText.remove();
			this.limitPremiumText = null;
		}
		setTimeout(() => {
			this.updateGenerateText();
		}, 0);
	}
	/**
	 *
	 * @param {boolean} isDisabled
	 * @returns
	 */
	handlePremiumBannerClick = (e) => {
		EventAnalytics.genDisabledBtnClick(this.node.globalId);
		e.stopPropagation();
		openPricingPage({ source: "tariffLimitedExecutor" });
	};

	toggleTarfiLimited(isDisabled) {
		if (this.tariffDisabled === isDisabled) {
			return;
		}
		this.tariffDisabled = isDisabled;
		this.executeBtn.classList.toggle("premiumDisabled", isDisabled);

		// Always remove both listeners first
		this.executeBtn.removeEventListener("click", this.executeFunc);
		this.executeBtn.removeEventListener("click", this.handlePremiumBannerClick);

		if (isNodeUnavalibleInGraphSpace(this.node.definition)) {
			this.executeBtnText.textContent = "Unavailable";
			this.creditsBadge.getDomElement().style.display = "none";
			this.executeBtn.classList.toggle("premiumDisabled", false);
			this.executeBtn.disabled = true;
			this.executeBtn.classList.add("unavalible");
			return;
		}
		if (isDisabled) {
			this.executeBtn.addEventListener("click", this.handlePremiumBannerClick);
			this.executeBtnText.textContent = "Upgrade to use";
			this.creditsBadge.getDomElement().style.display = "none";
		} else if (!this.isDisabled) {
			this.creditsBadge.getDomElement().style.display = "";
			this.executeBtn.addEventListener("click", this.executeFunc);
			setTimeout(() => {
				this.updateGenerateText();
			}, 0);
		}
	}
	setStatusEnabled(isEnabled) {
		this.statusElement.classList.toggle("hidden", !isEnabled);
	}

	/**
	 *
	 * @param {*} status
	 * @param {string|null} message
	 * @param {string|null} errorCode
	 */
	updateStatus(status, message = null, errorCode = null) {
		if (message) this.statusElement.textContent = message;

		this.DOMStyle.statusElement.style(status.toLowerCase());

		// Handle error state
		if (status === ExecutionStatus.Error && this.node?.layout) {
			this.node.layout.setErrorState(errorCode || "ERROR", message || "Unknown error");
		} else {
			this.node.layout.clearErrorState();
		}

		console.log(`${status.toUpperCase()}: ${message}`);
	}

	getLastStatusText() {
		return this.statusElement.textContent;
	}

	/**
	 *
	 * @param {HTMLElement} element
	 */
	appendStatus(element) {
		this.statusElement.append(element);
	}
	cancelTask() {
		this.DOMStyle.executeBlock.finish();
		NodeExecutionTask.stopTasksAsync([this.node]);
		this.cancelController.abort();
		this.cancelController = new AbortController();
	}
	isUserHasEnoughCredits() {
		return isUsercanRunPricedTask(this.node.getTaskPrice()?.price || 0, getUserStore());
	}
	/**
	 * @param {function(Promise<any>,
	 * ()=>any ,
	 * createdTaskId: createdTaskId:number,
	 * ()=>void,
	 * ()=>void)} executeAsyncFunc
	 */
	setExecuteFunction(executeAsyncFunc) {
		if (this.executeFunc) {
			this.executeBtn.removeEventListener("click", this.executeFunc);
		}
		let isExecuting = false;
		this.cancelController = new AbortController();
		let startTs;
		const executorFc = async () => {
			if (this.tariffDisabled || Editor.context.graph.nodesMovedExecutor) {
				return;
			}
			if (isExecuting) {
				EventAnalytics.cancelTask(
					this.node.globalId,
					this.node.taskID,
					Date.now() - startTs
				);
				this.updateStatus(ExecutionStatus.Ready, Default_Executor_Text);
				this.cancelTask();
				isExecuting = false;
				this.isExecuting = false;
				return;
			}
			if (!this.isUserHasEnoughCredits()) {
				showInsufficientCreditsToast();
				return;
			}
			const newCancelController = new AbortController();
			this.cancelController = newCancelController;
			startTs = Date.now();
			isExecuting = true;
			this.isExecuting = true;
			try {
				await executeAsyncFunc(newCancelController);
			} catch (_e) {}
			if (!newCancelController.signal.aborted) {
				this.isExecuting = false;
				isExecuting = false;
			}
		};
		this.executeFunc = executorFc;
		this.node.execute = executorFc;

		this.executeBtn.addEventListener("click", executorFc);
	}

	domElement() {
		return this.mainContainer;
	}

	initBasicTriggersDOM() {
		if (this.isBasicTriggersDOMInited) return;

		this.DOM.triggersContainer = $div("triggers-container", this.mainContainer);
		this.DOM.triggersContainer.style.display = "flex";
		this.DOM.triggersContainer.style.justifyContent = "space-between";

		this.DOM.triggersIn = $div("triggers-in", this.DOM.triggersContainer);
		this.DOM.triggersOut = $div("triggers-out", this.DOM.triggersContainer);
	}

	useEnterExitTriggers() {
		if (!this.isBasicTriggersDOMInited) this.initBasicTriggersDOM();

		this.triggerSockets.in.enter = new SocketIn(
			new SocketDefinition("Enter", "trigger"),
			this.node
		);
		this.triggerSockets.out.exit = new SocketOut(
			new SocketDefinition("Exit", "trigger"),
			this.node
		);

		this.DOM.triggersIn.append(this.triggerSockets.in.enter.layout.domElement());
		this.DOM.triggersOut.append(this.triggerSockets.out.exit.layout.domElement());

		this.node.triggerSocketsIn.push(this.triggerSockets.in.enter);
		this.node.triggerSocketsOut.push(this.triggerSockets.out.exit);
		this.isBasicTriggersDOMInited = true;
	}

	useBodyTrigger() {
		if (!this.isBasicTriggersDOMInited) this.initBasicTriggersDOM();

		this.triggerSockets.out.body = new SocketOut(
			new SocketDefinition("Body", "trigger"),
			this.node
		);
		this.DOM.triggersOut.append(this.triggerSockets.out.body.layout.domElement());
		this.node.triggerSocketsOut.push(this.triggerSockets.out.body);
		this.isBasicTriggersDOMInited = true;
	}

	async socketTriggeringAsync(socketTrigger) {
		if (!socketTrigger) return;

		const promises = socketTrigger.connections.map(
			(connection) => new Promise((res) => connection.socketIn.node.execute().then(res))
		);
		await Promise.all(promises).then();
	}
}
